import { Injectable } from '@angular/core';
import type { GDDLEvent, TaggedGDDLEvent } from '@analytics/models';

/**
 * Service responsible for adding output channel metadata to incoming events.
 */
@Injectable({
  providedIn: 'root',
})
export class DatalayerEventFilter {
  /**
   * Adds filtering metadata to a GDDL event based on it's shape.
   * @note this method is mostly infra for when we include multiple output channels
   * and does not apply any specific filtering tags yet.
   * @param event GDDL event that contains no output channel filtering metadata.
   * @returns GDDL event that contains output channel filtering metadata.
   */
  applyFilteringTagsToEvent(event: GDDLEvent): TaggedGDDLEvent {
    return { ...event, tags: ['all'] };
  }
}
